import { Person } from '@mui/icons-material';
import { Alert, Box, Drawer, Typography } from '@mui/material';
import CourseMenu from '@/components/course/course-menu';
import LoadingIndicator from '@/components/shared/loading-indicator';
import MainMenu from '@/components/shared/main-menu';
import { useAuth } from '@/providers';
import { useViewStore } from '@/stores';
import { useRoute } from '@/utils/client/route';
import packageJson from '../../../package.json';

export default function DrawerMenu() {
  const { isRoute } = useRoute();
  const { showMenuDrawer, toggleMenuDrawer } = useViewStore();
  const { isLoading, currentUser } = useAuth();

  return (
    <Drawer anchor="right" open={showMenuDrawer} onClose={toggleMenuDrawer} sx={{ zIndex: 1140 }}>
      <Box
        role="presentation"
        sx={{
          pt: { xs: 7, sm: 8 },
          display: 'flex',
          height: '100%',
          width: '100vw',
          maxWidth: 420,
          flexDirection: 'column',
        }}>
        {isLoading && <LoadingIndicator type="block" />}
        {!isLoading && (
          <>
            {currentUser && (
              <Alert sx={{ borderRadius: 0 }} severity="info" icon={<Person fontSize="inherit" />}>
                Du bist angemeldet als <strong>{currentUser.firstName}</strong>
              </Alert>
            )}
            {isRoute('myCourseLearn') ? <CourseMenu /> : <MainMenu />}
            <Box sx={{ p: 2, mt: 'auto' }}>
              <Typography variant="body2" display="block" color="text.secondary">
                Version {packageJson.version}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Drawer>
  );
}
